import React, { useContext, useState, useEffect, useRef } from "react"

import classNames from "@utils/classnames"

import Slider from "react-slick"
import CommonContext from "@src/context"
import Container from "@components/container"
import Clickable from "@components/clickable"
import styles from "./events.module.scss"


const events2020 = [
  {
    en: "WARM UP",
    title: "IDEA BATTLE",
    status: false,
    href: "http://alioss.gcores.com/site/spark_idea/",
  },
  {
    en: "SEASON 1",
    title: "线上资格赛",
    status: false,
    to: "/2020/season1",
  },
  {
    en: "SEASON 2",
    title: "线上资格赛",
    status: false,
    to: "/2020/season2",
  },
  {
    en: "SEASON 3",
    title: "线上赛",
    status: false,
    to: "/2020/season3",
  },
  {
    en: "SEASON 4",
    title: "第四赛季",
    status: false,
    to: "/2020/season4",
  },
  {
    en: "2021",
    title: "2021 赛季",
    status: '4.15 开始',
    to: "/2021/season1",
  },
]

const events2021 = [
  {
    en: "2020",
    title: "2020 赛季",
    status: false,
    to: "/2020/season1",
  },
  {
    en: "2021 SEASON 1",
    title: "资格赛",
    status: "4.15 ~ 5.16",
    to: "/2021/season1",
  },
  {
    en: "2021 SEASON 2",
    title: "资格赛",
    status: true,
  },
  {
    en: "2021 SEASON 3",
    title: "资格赛",
    status: true,
  },
]

const activeFind = (e, path) => e.to && new RegExp(e.to).test(path)

const sliderOptions = {
  centerMode: true,
  centerPadding: "60px",
  slidesToShow: 1,
  infinite: false,
  speed: 500,
  arrows: false,
  focusOnSelect: true,
}

const Events = () => {
  const sliderRef = useRef(null)
  const { winWidth, path } = useContext(CommonContext)
  const [initedKey, setInitedKey] = useState("waiting")
  const isMobileLayout = winWidth <= 700

  // 重新刷新以获得 active 状态
  useEffect(() => {
    setInitedKey("inited")
  }, [])

  const events = /2021/.test(path) ? events2021 : events2020

  const content = events.map((e, i) => {
    let statusMode
    let statusText
    if (e.status === false) {
      statusMode = "done"
      statusText = "已结束"
    } else if (e.status === true) {
      statusMode = "coming"
      statusText = "COMING SOON"
    } else {
      statusMode = "active"
      statusText = e.status
    }
    const linkProps = {
      to: e.to,
      href: e.href,
    }
    const className = classNames("box", styles.event, {
      "box-white": statusMode !== "coming",
      "box-ghost": statusMode === "coming",
      [styles.disabled]: statusMode === "coming",
      [styles.active]: activeFind(e, path),
    })
    return (
      <div key={`${e.title}${e.en}`}>
        <Clickable className={className} {...linkProps}>
          <div>
            <p>{e.en}</p>
            <h2>{e.title}</h2>
            <h3>{statusText}</h3>
          </div>
          {i !== events.length - 1 && <span className={styles.dots}>...</span>}
          <span className={styles.activeBar} />
        </Clickable>
      </div>
    )
  })
  return (
    <>
      <Container noPadding={isMobileLayout} key={initedKey}>
        {isMobileLayout ? (
          <Slider
            key={path}
            ref={sliderRef}
            {...sliderOptions}
            onInit={() => {
              const activeIndex = events.findIndex(e => activeFind(e, path))
              setTimeout(() => {
                if (sliderRef.current) {
                  sliderRef.current.slickGoTo(activeIndex)
                }
              }, 500)
            }}
          >
            {content}
          </Slider>
        ) : (
          <div className={styles.wrapper}>
            <div className={styles.events}>{content}</div>
          </div>
        )}
      </Container>
    </>
  )
}

export default Events
